<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <rule-table></rule-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ruleTable from './RuleTable.vue'

  export default {
    name: 'rule',
    components: {ruleTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/rule/Rule.vue